import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  ListSubheader,
  TextField,
  MenuItem,
  ListItemText
} from '@mui/material';
import { Close } from '@mui/icons-material';
// Import all CSS modules in the same order as parent to ensure consistent webpack ordering
// eslint-disable-next-line no-unused-vars
import _complainStyles from '../complain.module.css';
// eslint-disable-next-line no-unused-vars
import _deleteModalStyles from './delete.module.css';
// eslint-disable-next-line no-unused-vars
import _statusChangeStyles from './statusChange.module.css';
// eslint-disable-next-line no-unused-vars
import _viewStudentStyles from './viewStudent.module.css';
import styles from './reject_complaint.module.css';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { set } from 'date-fns';

const ForwardComplaint = ({ open, onClose, onConfirm, complaint }) => {
  const [remark, setRemark] = useState('');
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [error, setError] = useState(null);

  // const [categories, setCategories] = useState([]);
  const [categorySearch, setCategorySearch] = useState('');
  const [categoryTerm, setCategoryTerm] = useState('');
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [category,setCategory] = useState('');
 const [loading, setLoading] = useState(false);

  useEffect(() => { 
    setCategoryTerm('')
 }, [open]);

  const getAllCategories = async () => {
      try {
        setCategoryLoading(true);
        const baseUrl = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${baseUrl}/hospital/categorylist/specific`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('Token')}`
          }
        });
        const result = await response.json();

        console.log("Fetched categories:", result);

        const list = result?.data?.categories || result?.data?.data || result?.data || result?.categories || [];
        const normalized = Array.isArray(list)
          ? list
              .map((item) => {
                if (!item || typeof item !== 'object') return null;
                const id = item?.id || item?._id || item?.categoryId || item?.uuid;
                const name = item?.name || item?.categoryName || item?.title;
                return id && name ? { id: String(id), name: String(name) } : null;
              })
              .filter(Boolean)
          : [];
        setCategory(normalized);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setCategory([]);
      } finally {
        setCategoryLoading(false);
      }
    };


useEffect(() => {
  if (complaint) {
    setSelectedComplaint(complaint);
  }
}, [complaint]);

useEffect(() => {
  getAllCategories();
}, []);

if (!open) return null;

  console.log("Fetched categories outsid the fetc hfunction:", category);

  console.log("selected complaint:", categoryTerm);

  if (!open) return null;

  const handleForward = async () => {
    try {
      if (!remark) {
        toast.error('Remark cannot be empty.');
        return;
      }
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/hospital/forward/${selectedComplaint.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        },
        body: JSON.stringify({ 
           categoryId: categoryTerm,
      remark
         })
      });

      if (!response.ok) {
        throw new Error('Failed to forward complaint');
      }
      toast.success( response?.message || 'Complaint forwarded successfully');
      onConfirm && onConfirm();
      onClose();
      setRemark('');
    } catch (err) {

      setError(response?.message || response?.error || 'Failed to forward request');
      toast.error(response?.message || response?.error || 'Failed to forward request');
    }
    finally {
      setLoading(false);
    }
  };




  return (
    <Box className={styles.rejectModal} onClick={onClose}>
      <Box className={styles.forwardModalContent} onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <Box className={styles.rejectModalHeader}>
          <Typography className={styles.rejectModalTitle}>Forward Complaint Request</Typography>
          <IconButton
            className={styles.rejectCloseButton}
            onClick={() => {
              onClose();
              setRemark('');
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Modal Content */}
        <Box className={styles.rejectModalBody}>
          <Typography className={styles.rejectConfirmationText}>Are you sure you want to forward this complaint?</Typography>

          <Typography className={styles.rejectWarningText}>This action cannot be undone.</Typography>

          <Box className={styles.rejectRemarkSection}>
            {/* <Typography sx={{ width: '100%' }} className={styles.rejectRemarkLabel}>
              Categories
            </Typography> */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
              <FormControl size="small" className={styles.selectInput}>
                <InputLabel shrink id="category-label">
                  Categories
                </InputLabel>
                <Select
                  labelId="category-label"
                  value={categoryTerm}
                  label="Category"
                  onChange={(e) => setCategoryTerm(e.target.value)}
                  displayEmpty
                  renderValue={(selected) => category.find((cat) => String(cat.id) === String(selected))?.name || 'Select Category'}
                  MenuProps={{
                    disablePortal: true,
                    PaperProps: {
                      style: {
                        maxHeight: 280,
                        zIndex: 9999
                      }
                    },
                    MenuListProps: {
                      onKeyDown: (e) => {
                        e.stopPropagation();
                      }
                    }
                  }}
                >
                  <ListSubheader disableSticky>
                    <TextField
                      size="small"
                      placeholder="Search category"
                      value={categorySearch}
                      onChange={(e) => setCategorySearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => {
                        if (e.key !== 'Escape') {
                          e.stopPropagation();
                        }
                      }}
                      fullWidth
                    />
                  </ListSubheader>
                  {categoryLoading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : (
                    category
                      .filter((cat) =>
                        String(cat?.name || '')
                          .toLowerCase()
                          .includes(categorySearch.trim().toLowerCase())
                      )
                      .map((cat) => (
                        <MenuItem key={cat.id} value={cat.id}>
                          <ListItemText primary={cat.name} />
                        </MenuItem>
                      ))
                  )}
                </Select>
              </FormControl>
            </div>
          </Box>

          <Box className={styles.rejectRemarkSection}>
            <Typography className={styles.rejectRemarkLabel}>Remark</Typography>
            <textarea
              id="remark"
              name="remark"
              placeholder="Enter remark"
              className={styles.rejectRemarkTextarea}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Box>

        {/* Modal Footer */}
        <Box className={styles.rejectModalFooter}>
          <Button className={styles.rejectCancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button className={styles.holdConfirmButton} onClick={handleForward} disabled={loading}>
            {loading ? 'Forwarding...' : 'Yes, Forward'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ForwardComplaint;
